import { GENERAL_OPTION_SELECT } from '../constants/index';

export interface GeneralAction {
    type: 'GENERAL_OPTION_SELECT';
}
export type GeneralActions = GeneralAction;
export type GeneralSelect = (option: string) => void;

export const generalOptionSelect = (option: string, id: string) => {
    return function (dispatch: Function) {
        dispatch({
            type: GENERAL_OPTION_SELECT,
            payload: {
                option: parseInt(option, 10),
                id
            }
        });
    };
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/action/generalActions.ts